/** @type {((tag: Locale) => void) | undefined} */
let _onSetLocale = undefined;
export { localizeUrl, delocalizeUrl } from './routes';
/** The project's available language tags. */
export const locales = /** @type {const} */ ["sv"];
/**
 * A locale that is available in the project.
 * @typedef {typeof locales[number]} Locale
 */
/**
 * The project's source language tag.
 * @type {Locale}
 */
export const baseLocale = "sv";
/**
 * Get the current language tag.
 * @type {() => Locale}
 */
export let getLocale = () => baseLocale;
/**
 * Set the locale.
 * @param {Locale | (() => Locale)} locale
 */
export const setLocale = (locale) => {
    if (typeof locale === "function") {
        getLocale = enforceLocale(locale);
    }
    else {
        getLocale = enforceLocale(() => locale);
    }
    // call the callback function if it has been defined
    if (_onSetLocale !== undefined) {
        _onSetLocale(getLocale());
    }
};
/**
 * Wraps an untrusted function and enforces that it returns a locale.
 * @param {() => Locale} unsafeLocale
 * @returns {() => Locale}
 */
const enforceLocale = (unsafeLocale) => {
    return () => {
        const locale = unsafeLocale();
        if (!isLocaleAvailable(locale)) {
            throw new Error(`locale() didn't return a valid locale. Check your setLocale call`);
        }
        return locale;
    };
};
/**
 * Set the `onSetLocale()` callback function.
 * @param {(locale: Locale) => void} fn
 */
export const onSetLocale = (fn) => {
    _onSetLocale = fn;
};
/**
 * Check if something is an available language tag.
 * @param {string} locale
 * @returns {locale is Locale}
 */
export const isLocaleAvailable = (locale) => {
    return locales.includes(locale);
};
